const DEFAULT_MODE_SET = 'DEFAULT_MODE/SET';

export default function defaultModeSetAction(mode: number) {
  return {
    type: DEFAULT_MODE_SET,
    payload: {
      defaultMode: mode,
    },
  };
}

export { DEFAULT_MODE_SET };
